import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

const DURATION_MS = 5000;
const PLACEMENT = 'topRight';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {

  constructor(private notification: NzNotificationService) {}

  show(type: 'info' | 'success' | 'warning' | 'error', message: string): void {
    this.notification.create(type, this.titleFor(type), message, {
      nzDuration: DURATION_MS,
      nzPlacement: PLACEMENT,
    });
  }

  info(message: string): void {
    this.show('info', message);
  }

  success(message: string): void {
    this.show('success', message);
  }

  warning(message: string): void {
    this.show('warning', message);
  }

  error(message: string): void {
    this.show('error', message);
  }

  private titleFor(type: 'info' | 'success' | 'warning' | 'error'): string {
    const titles: Record<typeof type, string> = {
      info: 'Info',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
    };
    return titles[type];
  }
}
